import endpoints, { axios } from "../config/api";

function addUserToTask(projectId: number, taskId: number, userId: string) {
  return axios.post(endpoints.task.addUser(projectId, taskId), [userId]);
}

export default addUserToTask;
